import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataResponse, EventModel } from '../models';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class EventsApiService {

  constructor(private readonly httpService: HttpService) { }

  public getEventsList(filters: { [key: string]: string }): Observable<DataResponse<EventModel>> {
    const cleanedParams = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v != null)
    );

    const params = new HttpParams({ fromObject: cleanedParams });
    return this.httpService.get<DataResponse<EventModel>>('events', params);
  }

  public getEventById(id: string): Observable<EventModel> {
    const params = new HttpParams().set('id', id);

    return this.httpService.get<EventModel>('node', params);
  }


  public attendEvent(id: string): Observable<void> {
    return this.httpService.post<void>(`event/my-list/${id}`, null);
  }

  public cancelEventAttendace(id: string): Observable<void> {
    return this.httpService.delete<void>(`event/my-list/${id}`);
  }
}
